import { render } from "./editdealer.vue?vue&type=template&id=664907da&scoped=true"
import script from "./editdealer.vue?vue&type=script&lang=js"
export * from "./editdealer.vue?vue&type=script&lang=js"

import "./editdealer.vue?vue&type=style&index=0&id=664907da&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664907da"]])

export default __exports__